export default "__VITE_ASSET__DaoXSTJ$__"